import Mention from '@tiptap/extension-mention';

/** Mention extension (@user) with a dropdown search powered by Suggestion. */
export function buildMentionExtension(
  fetchUsers: (query: string) => Promise<Array<{ id: string; label: string }>>,
) {
  return Mention.configure({
    HTMLAttributes: { class: 'mention' },
    suggestion: {
      items: ({ query }: { query: string }) => fetchUsers(query),
      render: () => ({
        onStart: () => {},
        onUpdate: () => {},
        onKeyDown: () => false,
        onExit: () => {},
      }),
    },
  });
}
